module.exports = __webpack_public_path__ + "img/265-1.36041a33.jpg";